import { useEffect, useState } from 'react';
import { getActiveProfileId, onActiveProfileChange } from './activeProfile';

export function useActiveProfileId(): string | null {
  const [id, setId] = useState<string | null>(() => getActiveProfileId());
  useEffect(() => {
    return onActiveProfileChange(() => setId(getActiveProfileId()));
  }, []);
  return id;
}
